import { render, staticRenderFns } from "./spaceRequestsForm.vue?vue&type=template&id=b74e9308&scoped=true&"
import script from "./spaceRequestsForm.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74e9308",
  null
  
)

export default component.exports